// src/utils/protezioneChiusuraModali.js
// ═══════════════════════════════════════════════════════════════════════════
// FINESTRE CHE SI CHIUDEVANO DA SOLE (ottobre 2026)
// ═══════════════════════════════════════════════════════════════════════════
// Le finestre (noleggi, rapportini, DDT…) si chiudono con un clic sullo sfondo scuro.
// Problema: se si preme il mouse DENTRO la finestra (per esempio selezionando il testo di un
// campo o firmando) e lo si rilascia FUORI, il browser genera un «clic» sullo sfondo e la
// finestra si chiudeva, perdendo i dati inseriti.
// Qui, una sola volta per tutta l'app: un clic sullo sfondo vale solo se anche la pressione
// del mouse è iniziata sullo sfondo. Riguarda soltanto gli sfondi a tutto schermo
// (position: fixed che coprono la finestra del browser): pulsanti, righe e il resto dell'app
// non sono toccati.
// ═══════════════════════════════════════════════════════════════════════════

let partenza = null;

function eSfondoATuttoSchermo(el) {
  if (!(el instanceof Element)) return false;
  const st = window.getComputedStyle(el);
  if (st.position !== "fixed") return false;
  const r = el.getBoundingClientRect();
  return r.width >= window.innerWidth * 0.9 && r.height >= window.innerHeight * 0.9;
}

export function installaProtezioneChiusuraModali() {
  if (typeof document === "undefined" || window.__nxProtezioneModali) return;
  window.__nxProtezioneModali = true;
  document.addEventListener("mousedown", e => { partenza = e.target; }, true);
  document.addEventListener("click", e => {
    const p = partenza;
    partenza = null;
    // pressione iniziata dentro la finestra e rilasciata sullo sfondo: non è un clic sullo sfondo
    if (p && p !== e.target && e.target instanceof Element && e.target.contains(p) && eSfondoATuttoSchermo(e.target)) {
      e.stopPropagation();
      e.preventDefault();
    }
  }, true);
}
